import { render, staticRenderFns } from "./main.vue?vue&type=template&id=5dd6cdad&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dd6cdad')) {
      api.createRecord('5dd6cdad', component.options)
    } else {
      api.reload('5dd6cdad', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=5dd6cdad&", function () {
      api.rerender('5dd6cdad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/merchant/child/main.vue"
export default component.exports